import { Box, Divider, Skeleton, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { RubricCore } from 'Types/dealGPT';

import { getTileColor } from './rubricUtils';

interface RubricOverallRatingProps {
  rating: string;
  rubricCore: RubricCore[];
  rubricType: string;
  loading?: boolean;
}

const RubricRating: React.FC<RubricOverallRatingProps> = ({
  rating,
  rubricCore,
  rubricType,
  loading,
}) => {
  const isLMH = useMemo(() => rubricType === 'LMH', [rubricType]);

  const scaleValues = useMemo(
    () =>
      isLMH
        ? ['Low', 'Medium', 'High']
        : (() => {
            const values = [];
            for (let i = 0; i < Number(rubricType); i++) {
              values.push(i);
            }
            return values;
          })(),
    [isLMH, rubricType]
  );

  const selectedRubric = useMemo(
    () =>
      rubricCore.find(
        (core) =>
          core.maturityLevelDisplayName === rating || core.maturityLevel === parseInt(rating)
      ),
    [rubricCore, rating]
  );

  if (loading)
    return (
      <Box display="flex" border="1px solid #C4C4C4" padding={1} gap={2}>
        {scaleValues.map((i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width={`calc(100%/${scaleValues.length})`}
            height={150}
          />
        ))}
      </Box>
    );

  return (
    <Box display="flex" border="1px solid #C4C4C4" padding={1} gap={2}>
      {rubricCore.map((rubric) => (
        <Box
          key={rubric.id}
          display="flex"
          flexDirection="column"
          flex="1 1 0px"
          border={rubric === selectedRubric ? '1px solid #C4C4C4' : 'none'}
          sx={{
            backgroundColor:
              rubric === selectedRubric
                ? getTileColor(
                    0,
                    selectedRubric.maturityLevel,
                    rubricType === 'LMH' ? 3 : Number(rubricType)
                  )
                : 'transparent',
          }}
          borderRadius="10px"
          padding={1}
          gap={1}
        >
          <Typography>
            Rating:{' '}
            <span
              style={{
                color:
                  rubric !== selectedRubric
                    ? getTileColor(
                        0,
                        rubric.maturityLevel,
                        rubricType === 'LMH' ? 3 : Number(rubricType)
                      )
                    : 'inherit',
              }}
            >
              {rubric.maturityLevelDisplayName ?? rubric.maturityLevel}
            </span>
          </Typography>
          <Divider />
          <Typography>{rubric.description}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default RubricRating;
